import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/shadcn/dialog";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { useEffect, useState } from "react";
import { Button } from "./shadcn/button";

const AskidaSuccessModal = ({ isOpen }: { isOpen: boolean }) => {
    const t = useTranslations("checkout");
    const [alertOpen, setAlertOpen] = useState<boolean>(false);

    useEffect(() => {
        if (isOpen === true) {
            setAlertOpen(true);
        } else {
            setAlertOpen(false);
        }
    }, [isOpen]);

    const handleOnClick = () => {
        setAlertOpen(false);
        window.location.assign("/");
        //router.push("/");

        //set isPremium true
    };

    return (
        <Dialog open={alertOpen} onOpenChange={setAlertOpen}>
            <DialogContent
                showCloseButton={false}
                onInteractOutside={(e) => {
                    e.preventDefault();
                }}
            >
                <DialogHeader>
                    <DialogTitle className="w-full text-center">
                        {t("askidaSuccessTitle")}
                    </DialogTitle>
                    <Image
                        src="/images/askida-modal.png"
                        alt=""
                        width={150}
                        height={150}
                        className="mx-auto"
                    />
                    <DialogDescription className="w-full text-center">
                        {t("askidaSuccessBody")}
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button type="submit" onClick={handleOnClick}>
                        {t("startLearning")}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
export default AskidaSuccessModal;
